import React, { Component } from "react";
import StoneByMonthItem from "./StoneByMonthItem";

export default class StoneByMonthList extends Component {
  render() {
    let { month, productList, handleUpdateState } = this.props;

    return (
      <li className="birth-stone">
        <div className="wrap-month">
          <span className="title">{month.name}</span>
        </div>

        <ul className="birth_stone_list">
          {month.product_ids.map((item, index) => (
            <StoneByMonthItem
              key={index}
              item={item}
              productList={productList}
              handleUpdateState={handleUpdateState}
            />
          ))}
        </ul>
      </li>
    );
  }
}
